import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import VForm17Open from './VForm17Open.vue' 

declareVconsoleComponent('vForm17Open', VForm17Open)